import React from "react";

/* eslint-disable max-len */
export default function SlidePrevIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={20} height={40} viewBox="0 0 20 40">
            <path d="M0 37.5L2.223 40 20 20 2.223 0 0 2.5 15.555 20z" fill="#fff" />
        </svg>
    );
}
